"use client";

import useSWR from "swr";

export function useServiceReviews() {
  const url = `${process.env.NEXT_PUBLIC_API_HOST}/api/user/service-reviews/?service_type=platform`;

  const fetcher = (url: string) =>
    fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }).then((res) => res.json());

  const { data, error, isLoading, mutate } = useSWR(url, fetcher);

  return {
    reviews: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}
